// REAL businesses across Albania, Kosovo & North Macedonia — all categories.
// Each entry follows the exact BUSINESSES card structure from mockData.js.
// `coords` = [lat, lng] — auto-merged into the interactive map (mapData.js).

const u = (id) => `https://images.unsplash.com/photo-${id}?w=1200&q=80`;
const px = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=1200`;

export const REAL_BUSINESSES = [
  // ================= TIRANA =================
  {
    id: 'r-era-tirana', slug: 'era-restaurant-tirana', name: 'Era Restaurant', category: 'restaurant',
    city: 'tirana', country: 'albania', rating: 4.6, reviews: 4820, price: '$$', status: 'open',
    address: 'Rruga Ismail Qemali 33, Blloku, Tirana', coords: [41.3186, 19.8166],
    image: u('1414235077428-338989a2e8c0'), website: 'https://era.al',
    hours: 'Mon–Sun 11:00–23:30',
    description: 'Tirana institution serving traditional Albanian and Mediterranean dishes in the heart of Blloku since 1999.',
    tags: ['Albanian cuisine', 'Byrek', 'Qofte', 'Local favorite'], featured: true, verified: true,
  },
  {
    id: 'r-salt-tirana', slug: 'salt-restaurant-tirana', name: 'Salt Tirana', category: 'restaurant', secondaryCategories: ['seafood'],
    city: 'tirana', country: 'albania', rating: 4.7, reviews: 2140, price: '$$$$', status: 'open',
    address: 'Rruga Sami Frashëri, Blloku, Tirana', coords: [41.3192, 19.8131],
    image: u('1559339352-11d035aa65de'),
    hours: 'Mon–Sun 12:00–00:00',
    description: 'Upscale seafood and sushi destination — raw bar, signature cocktails and one of the most stylish dining rooms in the capital.',
    tags: ['Seafood', 'Sushi', 'Fine dining', 'Cocktails'], featured: true, verified: true,
  },
  {
    id: 'r-artigiano-tirana', slug: 'artigiano-vila-tirana', name: 'Artigiano Vila', category: 'restaurant',
    city: 'tirana', country: 'albania', rating: 4.5, reviews: 1860, price: '$$$', status: 'open',
    address: 'Rruga Abdyl Frashëri, Blloku, Tirana', coords: [41.3179, 19.8125],
    image: u('1517248135467-4c7edcad34c4'),
    hours: 'Mon–Sun 12:00–23:00',
    description: 'Beloved Italian trattoria in a restored villa — handmade pasta, wood-fired pizza and a serious wine cellar.',
    tags: ['Italian', 'Pizza', 'Pasta', 'Wine'], featured: false, verified: true,
  },
  {
    id: 'r-padam-tirana', slug: 'padam-boutique-hotel-tirana', name: 'Padam Boutique Hotel', category: 'hotel',
    city: 'tirana', country: 'albania', rating: 4.7, reviews: 980, price: '$$$$', status: 'open',
    address: 'Rruga e Elbasanit, Tirana', coords: [41.3231, 19.8262],
    image: u('1582719508461-905c673771fd'),
    description: 'Elegant boutique hotel in a restored 1930s villa with a gourmet restaurant and leafy garden terrace.',
    tags: ['Boutique', '5-star service', 'Garden', 'Fine dining'], featured: true, verified: true,
  },
  {
    id: 'r-plaza-tirana', slug: 'plaza-tirana-hotel', name: 'Maritim Hotel Plaza Tirana', category: 'hotel',
    city: 'tirana', country: 'albania', rating: 4.6, reviews: 2460, price: '$$$$', status: 'open',
    address: 'Rruga 28 Nëntori, City Center, Tirana', coords: [41.3290, 19.8211],
    image: u('1566073771259-6a8506099945'),
    description: '5-star landmark tower steps from Skanderbeg Square — panoramic rooms, spa, indoor pool and rooftop dining.',
    tags: ['5-star', 'Spa', 'City center', 'Business'], featured: true, verified: true,
  },
  {
    id: 'r-rogner-tirana', slug: 'rogner-hotel-tirana', name: 'Rogner Hotel Tirana', category: 'hotel',
    city: 'tirana', country: 'albania', rating: 4.5, reviews: 1890, price: '$$$', status: 'open',
    address: 'Bulevardi Dëshmorët e Kombit, Tirana', coords: [41.3218, 19.8222],
    image: px('37569474'),
    description: 'Garden-oasis hotel on the main boulevard with outdoor pool, tennis court and legendary Sunday brunch.',
    tags: ['Garden', 'Pool', 'Boulevard', 'Brunch'], featured: false, verified: true,
  },
  {
    id: 'r-skytower-tirana', slug: 'sky-tower-bar-tirana', name: 'Sky Tower Rotating Bar', category: 'lounge', secondaryCategories: ['bar'],
    city: 'tirana', country: 'albania', rating: 4.4, reviews: 1620, price: '$$$', status: 'open',
    address: 'Rruga Dëshmorët e 4 Shkurtit, Tirana', coords: [41.3214, 19.8155],
    image: u('1470337458703-46ad1756a187'),
    hours: 'Mon–Sun 09:00–00:00',
    description: 'Tirana\'s famous revolving panoramic bar — 360° city views with coffee by day and cocktails by night.',
    tags: ['Panoramic view', 'Rotating floor', 'Cocktails', 'Sunset'], featured: true, verified: true,
  },
  {
    id: 'r-radio-tirana', slug: 'radio-bar-tirana', name: 'Radio Bar', category: 'bar',
    city: 'tirana', country: 'albania', rating: 4.6, reviews: 1140, price: '$$', status: 'open',
    address: 'Rruga Ismail Qemali 29/1, Blloku, Tirana', coords: [41.3189, 19.8157],
    image: u('1551024709-8f23befc6f87'),
    hours: 'Mon–Sun 18:00–02:00',
    description: 'Cult retro bar filled with vintage radios — craft cocktails, vinyl nights and Blloku\'s coolest crowd.',
    tags: ['Retro', 'Cocktails', 'Vinyl', 'Local crowd'], featured: false, verified: true,
  },
  {
    id: 'r-nouvellevague-tirana', slug: 'nouvelle-vague-tirana', name: 'Nouvelle Vague', category: 'cocktail-bar',
    city: 'tirana', country: 'albania', rating: 4.7, reviews: 980, price: '$$$', status: 'open',
    address: 'Rruga Pjetër Bogdani, Blloku, Tirana', coords: [41.3180, 19.8146],
    image: u('1514933651103-005eec06c04b'),
    hours: 'Mon–Sun 18:00–02:00',
    description: 'Award-winning cocktail bar ranked among the best in the Balkans — inventive signatures and impeccable service.',
    tags: ['Craft cocktails', 'Mixology', 'Date night'], featured: true, verified: true,
  },
  {
    id: 'r-komiteti-tirana', slug: 'komiteti-kafe-muzeum', name: 'Komiteti — Kafe Muzeum', category: 'cafe', secondaryCategories: ['bar'],
    city: 'tirana', country: 'albania', rating: 4.7, reviews: 2380, price: '$', status: 'open',
    address: 'Rruga Fatmir Haxhiu, Tirana', coords: [41.3225, 19.8240],
    image: u('1554118811-1e0d58224f24'),
    hours: 'Mon–Sun 09:00–00:00',
    description: 'Café-museum packed with communist-era memorabilia, 30+ raki varieties and the best mountain tea in town.',
    tags: ['Raki', 'Museum café', 'Retro', 'Mountain tea'], featured: true, verified: true,
  },
  {
    id: 'r-mulliri-tirana', slug: 'mulliri-i-vjeter-tirana', name: 'Mulliri i Vjetër', category: 'cafe',
    city: 'tirana', country: 'albania', rating: 4.4, reviews: 1560, price: '$', status: 'open',
    address: 'Rruga e Kavajës, Tirana (multiple locations)', coords: [41.3265, 19.8120],
    image: u('1495474472287-4d71bcdd2085'),
    hours: 'Mon–Sun 07:00–22:00',
    description: 'Albania\'s favorite coffee chain — freshly roasted espresso, pastries and a warm rustic atmosphere.',
    tags: ['Coffee roastery', 'Breakfast', 'Pastries'], featured: false, verified: true,
  },
  {
    id: 'r-bunkart1-tirana', slug: 'bunkart-1-tirana', name: "Bunk'Art 1", category: 'museum', secondaryCategories: ['attraction'],
    city: 'tirana', country: 'albania', rating: 4.7, reviews: 5240, price: '$', status: 'open',
    address: 'Rruga Fadil Deliu, near Dajti Ekspres, Tirana', coords: [41.3445, 19.8916],
    image: u('1705405999485-188af37e0462'),
    hours: 'Wed–Sun 09:00–16:00',
    description: 'Massive 5-storey Cold-War bunker turned history & art museum — Albania\'s most haunting must-see.',
    tags: ['Cold War', 'History', 'Underground', 'Must-see'], featured: true, verified: true,
  },
  {
    id: 'r-natmuseum-tirana', slug: 'national-history-museum-tirana', name: 'National History Museum', category: 'museum',
    city: 'tirana', country: 'albania', rating: 4.4, reviews: 3120, price: '$', status: 'open',
    address: 'Sheshi Skënderbej 7, Tirana', coords: [41.3286, 19.8178],
    image: px('13288802'),
    hours: 'Tue–Sun 09:00–17:00',
    description: 'Albania\'s largest museum under the iconic "The Albanians" mosaic — from Illyrian gold to the communist era.',
    tags: ['History', 'Skanderbeg Square', 'Mosaic'], featured: false, verified: true,
  },
  {
    id: 'r-grandpark-tirana', slug: 'grand-park-tirana', name: 'Grand Park of Tirana', category: 'park',
    city: 'tirana', country: 'albania', rating: 4.6, reviews: 4480, price: '$', status: 'open',
    address: 'Liqeni Artificial, Tirana', coords: [41.3110, 19.8260],
    image: u('1441974231531-c6227db76b6e'),
    hours: 'Open 24/7',
    description: '230 hectares of green around the artificial lake — running trails, open-air amphitheatre and lakeside cafés.',
    tags: ['Lake', 'Running', 'Picnic', 'Free entry'], featured: false, verified: true,
  },
  {
    id: 'r-dajti-tirana', slug: 'dajti-ekspres-cable-car', name: 'Dajti Ekspres Cable Car', category: 'attraction',
    city: 'tirana', country: 'albania', rating: 4.6, reviews: 6180, price: '$$', status: 'open',
    address: 'Rruga Shtëpia e Pushimit, Tirana', coords: [41.3439, 19.8923],
    image: u('1693323243729-b1609557938f'),
    hours: 'Tue–Sun 09:00–19:00',
    description: 'The longest cable car in the Balkans — 15 minutes from the city to 1,613m Dajti Mountain with epic views.',
    tags: ['Cable car', 'Mountain', 'Views', 'Family'], featured: true, verified: true,
  },
  {
    id: 'r-teg-tirana', slug: 'tirana-east-gate', name: 'TEG — Tirana East Gate', category: 'shopping',
    city: 'tirana', country: 'albania', rating: 4.5, reviews: 8240, price: '$$', status: 'open',
    address: 'Rruga Tiranë–Elbasan, Farkë, Tirana', coords: [41.2960, 19.8870],
    image: u('1441986300917-64674bd600d8'),
    hours: 'Mon–Sun 10:00–22:00',
    description: 'Albania\'s biggest shopping mall — 200+ international brands, cinema, food court and free parking.',
    tags: ['Mall', 'Brands', 'Cinema', 'Food court'], featured: false, verified: true,
  },
  {
    id: 'r-toptani-tirana', slug: 'toptani-shopping-center', name: 'Toptani Shopping Center', category: 'shopping',
    city: 'tirana', country: 'albania', rating: 4.4, reviews: 3860, price: '$$', status: 'open',
    address: 'Rruga Abdi Toptani, Tirana', coords: [41.3267, 19.8222],
    image: u('1441986300917-64674bd600d8'),
    hours: 'Mon–Sun 10:00–22:00',
    description: 'Modern city-center mall with rooftop terrace bars overlooking Skanderbeg Square.',
    tags: ['City center', 'Rooftop', 'Fashion'], featured: false, verified: true,
  },
  {
    id: 'r-neptun-tirana', slug: 'neptun-electronics-tirana', name: 'Neptun Electronics', category: 'electronics',
    city: 'tirana', country: 'albania', rating: 4.3, reviews: 1980, price: '$$', status: 'open',
    address: 'Rruga Myslym Shyri, Tirana (flagship)', coords: [41.3245, 19.8090],
    image: u('1550009158-9ebf69173e03'),
    hours: 'Mon–Sun 09:00–21:00',
    description: 'The largest electronics retailer in Albania — TVs, laptops, appliances and phones with official warranty.',
    tags: ['Electronics', 'Appliances', 'Warranty'], featured: false, verified: true,
  },
  {
    id: 'r-folie-tirana', slug: 'folie-terrace-tirana', name: 'Folie Terrace', category: 'nightclub',
    city: 'tirana', country: 'albania', rating: 4.5, reviews: 2240, price: '$$$', status: 'open',
    address: 'Near Grand Park, Tirana', coords: [41.3155, 19.8268],
    image: u('1566737236500-c8ac43014a67'),
    hours: 'Fri–Sun 22:00–05:00',
    description: 'Tirana\'s premier open-air club — international DJs, summer terrace parties and a world-class sound system.',
    tags: ['Open-air', 'DJ sets', 'Summer parties'], featured: true, verified: true,
  },
  {
    id: 'r-merrtaxi-tirana', slug: 'merr-taxi-tirana', name: 'Merr Taxi', category: 'taxi',
    city: 'tirana', country: 'albania', rating: 4.4, reviews: 2680, price: '$', status: 'open',
    address: 'Citywide service, Tirana', coords: [41.3300, 19.8150],
    image: px('13288802'), phone: '+35542444444',
    hours: '24/7',
    description: 'Tirana\'s largest licensed taxi fleet — app booking, fixed airport rates and English-speaking dispatch.',
    tags: ['24/7', 'Airport transfer', 'App booking'], featured: false, verified: true,
  },
  {
    id: 'r-hertz-tirana', slug: 'hertz-tirana-airport', name: 'Hertz Car Rental — Tirana Airport', category: 'car-rental',
    city: 'tirana', country: 'albania', rating: 4.2, reviews: 860, price: '$$$', status: 'open',
    address: 'Tirana International Airport Nënë Tereza, Rinas', coords: [41.4147, 19.7206],
    image: u('1502877338535-766e1452684a'),
    hours: 'Mon–Sun 07:00–23:00',
    description: 'International car rental desk at Rinas airport — SUVs for the Riviera, automatics and full insurance options.',
    tags: ['Airport pickup', 'SUV', 'Insurance'], featured: false, verified: true,
  },
  {
    id: 'r-outdooralbania-tirana', slug: 'outdoor-albania-tours', name: 'Outdoor Albania', category: 'tour',
    city: 'tirana', country: 'albania', rating: 4.9, reviews: 740, price: '$$$', status: 'open',
    address: 'Rruga Sami Frashëri, Tirana', coords: [41.3204, 19.8139],
    image: u('1551632811-561732d1e306'), website: 'https://outdooralbania.com',
    description: 'Albania\'s pioneer adventure tour operator since 1992 — hiking, rafting, sea kayaking and Albanian Alps treks.',
    tags: ['Hiking', 'Rafting', 'Alps treks', 'Since 1992'], featured: true, verified: true,
  },
  {
    id: 'r-empirefitness-tirana', slug: 'empire-fitness-tirana', name: 'Empire Fitness', category: 'gym',
    city: 'tirana', country: 'albania', rating: 4.5, reviews: 620, price: '$$', status: 'open',
    address: 'Rruga e Kavajës, Tirana', coords: [41.3236, 19.8050],
    image: u('1534438327276-14e5300c3a48'),
    hours: 'Mon–Sat 06:00–23:00 · Sun 08:00–21:00',
    description: 'Premium fitness club with modern equipment, group classes, sauna and day passes for travelers.',
    tags: ['Day pass', 'Classes', 'Sauna'], featured: false, verified: true,
  },
  {
    id: 'r-americanhospital-tirana', slug: 'american-hospital-tirana', name: 'American Hospital Tirana', category: 'hospital',
    city: 'tirana', country: 'albania', rating: 4.3, reviews: 1240, price: '$$$', status: 'open',
    address: 'Rruga e Dibrës, Laprakë, Tirana', coords: [41.3400, 19.8268],
    image: u('1586773860418-d37222d8fce3'), phone: '+35542357535',
    hours: '24/7 Emergency',
    description: 'The leading private hospital network in Albania — 24/7 ER, English-speaking doctors and international insurance accepted.',
    tags: ['24/7 ER', 'English-speaking', 'Insurance'], featured: false, verified: true,
  },
  {
    id: 'r-adams-tirana', slug: 'barnatore-adams-tirana', name: 'Barnatore Adams', category: 'pharmacy',
    city: 'tirana', country: 'albania', rating: 4.5, reviews: 480, price: '$', status: 'open',
    address: 'Bulevardi Zogu I, near Skanderbeg Square, Tirana', coords: [41.3291, 19.8168],
    image: u('1576602976047-174e57a47881'),
    hours: '24/7',
    description: 'Central 24-hour pharmacy near Skanderbeg Square — international medicines and English-speaking pharmacists.',
    tags: ['24/7', 'English-speaking', 'Central'], featured: false, verified: true,
  },

  // ================= DURRËS =================
  {
    id: 'r-adriatik-durres', slug: 'hotel-adriatik-durres', name: 'Hotel Adriatik', category: 'hotel',
    city: 'durres', country: 'albania', rating: 4.6, reviews: 1780, price: '$$$$', status: 'open',
    address: 'Plazhi i Durrësit, Durrës', coords: [41.2899, 19.5040],
    image: u('1571896349842-33c89424de2d'),
    description: 'The grande dame of the Albanian coast since 1957 — 5-star beachfront resort with private beach, pools and spa.',
    tags: ['5-star', 'Private beach', 'Spa', 'Pool'], featured: true, verified: true,
  },
  {
    id: 'r-aragosta-durres', slug: 'aragosta-durres', name: 'Ristorante Aragosta', category: 'seafood', secondaryCategories: ['restaurant'],
    city: 'durres', country: 'albania', rating: 4.5, reviews: 1320, price: '$$$', status: 'open',
    address: 'Rruga Taulantia, Durrës seafront', coords: [41.3104, 19.4445],
    image: u('1559339352-11d035aa65de'),
    hours: 'Mon–Sun 12:00–23:00',
    description: 'Iconic seafront seafood restaurant — lobster tanks, Adriatic catch of the day and sunset terrace dining.',
    tags: ['Lobster', 'Sea view', 'Fresh catch'], featured: false, verified: true,
  },

  // ================= SARANDA =================
  {
    id: 'r-marenostrum-saranda', slug: 'mare-nostrum-saranda', name: 'Mare Nostrum Cuisine', category: 'restaurant', secondaryCategories: ['seafood'],
    city: 'saranda', country: 'albania', rating: 4.7, reviews: 2480, price: '$$$', status: 'open',
    address: 'Rruga Jonianët, Saranda promenade', coords: [39.8735, 20.0072],
    image: u('1555396273-367ea4eb4db5'),
    hours: 'Mon–Sun 12:00–23:30',
    description: 'Saranda\'s top-rated fine dining — Ionian seafood with Mediterranean technique right on the promenade.',
    tags: ['Fine dining', 'Seafood', 'Promenade'], featured: true, verified: true,
  },
  {
    id: 'r-guvat-saranda', slug: 'guvat-bar-saranda', name: 'Guvat Bar & Restaurant', category: 'beach-bar', secondaryCategories: ['restaurant'],
    city: 'saranda', country: 'albania', rating: 4.6, reviews: 1860, price: '$$', status: 'open',
    address: 'Rruga Butrinti, carved into the rocks, Saranda', coords: [39.8728, 20.0102],
    image: u('1533105079780-92b9be482077'),
    hours: 'Mon–Sun 09:00–00:00',
    description: 'Legendary bar built into the sea cliffs — swim from the rocks, then cocktails at sunset over the Ionian.',
    tags: ['Cliff bar', 'Swimming', 'Sunset'], featured: true, verified: true,
  },
  {
    id: 'r-santaquaranta-saranda', slug: 'santa-quaranta-resort', name: 'Santa Quaranta Premium Resort', category: 'hotel',
    city: 'saranda', country: 'albania', rating: 4.7, reviews: 1420, price: '$$$$', status: 'open',
    address: 'Rruga Butrinti, Saranda', coords: [39.8645, 20.0186],
    image: u('1551882547-ff40c63fe5fa'),
    description: '5-star adults-friendly resort with infinity pools, private beach deck and Ksamil-blue water views.',
    tags: ['5-star', 'Infinity pool', 'Beach deck'], featured: true, verified: true,
  },
  {
    id: 'r-pasqyra-saranda', slug: 'mirror-beach-saranda', name: 'Pasqyra (Mirror) Beach', category: 'beach',
    city: 'saranda', country: 'albania', rating: 4.7, reviews: 3240, price: '$', status: 'open',
    address: 'Rruga Saranda–Ksamil, 8 km from Saranda', coords: [39.8424, 20.0353],
    image: u('1507525428034-b723cf961d3e'),
    description: 'Glass-clear cove framed by white cliffs — the water really does mirror the sky. Arrive early in summer.',
    tags: ['Crystal water', 'Cove', 'Snorkeling'], featured: true, verified: false,
  },

  // ================= KSAMIL =================
  {
    id: 'r-poda-ksamil', slug: 'poda-boutique-hotel-ksamil', name: 'Poda Boutique Hotel', category: 'hotel',
    city: 'ksamil', country: 'albania', rating: 4.8, reviews: 860, price: '$$$$', status: 'open',
    address: 'Rruga e Ishujve, Ksamil', coords: [39.7726, 20.0000],
    image: u('1582719508461-905c673771fd'),
    description: 'Chic boutique stay two minutes from the Ksamil islands — rooftop breakfast and curated beach access.',
    tags: ['Boutique', 'Rooftop', 'Near islands'], featured: true, verified: true,
  },
  {
    id: 'r-borabora-ksamil', slug: 'bora-bora-beach-ksamil', name: 'Bora Bora Beach Club', category: 'beach-club',
    city: 'ksamil', country: 'albania', rating: 4.5, reviews: 1480, price: '$$$', status: 'open',
    address: 'South Ksamil beachfront', coords: [39.7635, 19.9990],
    image: u('1533105079780-92b9be482077'),
    hours: 'May–Oct 09:00–00:00',
    description: 'Maldives-style sunbeds over turquoise shallows — daybeds, DJ sundowners and fresh seafood platters.',
    tags: ['Daybeds', 'DJ', 'Turquoise water'], featured: true, verified: true,
  },
  {
    id: 'r-pulebardha-ksamil', slug: 'pulebardha-beach-ksamil', name: 'Pulëbardha Beach', category: 'beach',
    city: 'ksamil', country: 'albania', rating: 4.6, reviews: 1240, price: '$', status: 'open',
    address: 'North of Ksamil, toward Saranda', coords: [39.7807, 19.9968],
    image: u('1519046904884-53103b34b206'),
    description: 'Quieter white-pebble bay loved by locals — calm shallow water, olive groves and two family-run beach bars.',
    tags: ['Quiet', 'Family', 'Shallow water'], featured: false, verified: false,
  },

  // ================= VLORA =================
  {
    id: 'r-zvernec-vlora', slug: 'zvernec-monastery-vlora', name: 'Zvërnec Island & Monastery', category: 'attraction',
    city: 'vlora', country: 'albania', rating: 4.6, reviews: 1680, price: '$', status: 'open',
    address: 'Narta Lagoon, 10 km north of Vlora', coords: [40.5128, 19.4108],
    image: u('1559827260-dc66d52bef19'),
    description: '13th-century Byzantine monastery on a pine-covered island, reached by a 270m wooden footbridge over the lagoon.',
    tags: ['Monastery', 'Island', 'Footbridge', 'Photo spot'], featured: true, verified: false,
  },
  {
    id: 'r-vlorainternational-vlora', slug: 'hotel-vlora-international', name: 'Hotel Vlora International', category: 'hotel',
    city: 'vlora', country: 'albania', rating: 4.4, reviews: 1120, price: '$$$', status: 'open',
    address: 'Lungomare, Vlora seafront', coords: [40.4553, 19.4853],
    image: u('1566073771259-6a8506099945'),
    description: 'Seafront tower on Vlora\'s famous Lungomare promenade — bay-view rooms, pool and beach service.',
    tags: ['Lungomare', 'Sea view', 'Pool'], featured: false, verified: true,
  },

  // ============ HIMARA / DHËRMI / JALË ============
  {
    id: 'r-foliemarine-himare', slug: 'folie-marine-jale', name: 'Folie Marine', category: 'beach-club',
    city: 'himare', country: 'albania', rating: 4.5, reviews: 1960, price: '$$$$', status: 'open',
    address: 'Jalë Beach, Himarë', coords: [40.1320, 19.7030],
    image: u('1533105079780-92b9be482077'),
    hours: 'Jun–Sep 10:00–04:00',
    description: 'The Riviera\'s most famous beach club — international headliners, infinity deck and Jalë\'s electric summer nights.',
    tags: ['International DJs', 'Beachfront', 'Summer'], featured: true, verified: true,
  },
  {
    id: 'r-gjipe-himare', slug: 'gjipe-beach', name: 'Gjipe Beach & Canyon', category: 'beach',
    city: 'himare', country: 'albania', rating: 4.8, reviews: 2640, price: '$', status: 'open',
    address: 'Between Dhërmi and Jalë (30-min hike or boat)', coords: [40.1230, 19.6860],
    image: u('1519046904884-53103b34b206'),
    description: 'Wild beach where a dramatic canyon meets the sea — reachable only by foot or boat, worth every step.',
    tags: ['Wild beach', 'Canyon', 'Hike', 'Camping'], featured: true, verified: false,
  },
  {
    id: 'r-rapos-himare', slug: 'rapos-resort-himare', name: 'Rapos Resort Hotel', category: 'hotel',
    city: 'himare', country: 'albania', rating: 4.5, reviews: 920, price: '$$$$', status: 'open',
    address: 'Spile Beach, Himarë', coords: [40.1085, 19.7530],
    image: u('1571896349842-33c89424de2d'),
    description: 'Beachfront resort on Spile bay — seawater pool, gardens and the Riviera\'s calmest 5-star service.',
    tags: ['Beachfront', 'Pool', 'Family'], featured: false, verified: true,
  },
  {
    id: 'r-havana-dhermi', slug: 'havana-beach-club-dhermi', name: 'Havana Beach Club', category: 'beach-club',
    city: 'dhermi', country: 'albania', rating: 4.4, reviews: 1380, price: '$$$', status: 'open',
    address: 'Dhërmi Beach', coords: [40.1640, 19.6330],
    image: u('1507525428034-b723cf961d3e'),
    hours: 'May–Sep 09:00–02:00',
    description: 'Dhërmi classic — white pebbles, turquoise shallows, daybeds by day and beach parties after dark.',
    tags: ['Beach parties', 'Daybeds', 'Cocktails'], featured: false, verified: true,
  },
  {
    id: 'r-drymades-dhermi', slug: 'drymades-beach', name: 'Drymades Beach', category: 'beach',
    city: 'dhermi', country: 'albania', rating: 4.7, reviews: 1820, price: '$', status: 'open',
    address: 'North of Dhërmi village', coords: [40.1605, 19.6320],
    image: u('1507525428034-b723cf961d3e'),
    description: 'Long white-stone beach under olive terraces — clearer, quieter and more local than its famous neighbor.',
    tags: ['White stones', 'Olive groves', 'Sunbeds'], featured: false, verified: false,
  },

  // ================= SHKODËR =================
  {
    id: 'r-rozafa-shkoder', slug: 'rozafa-castle-shkoder', name: 'Rozafa Castle', category: 'attraction',
    city: 'shkoder', country: 'albania', rating: 4.7, reviews: 4120, price: '$', status: 'open',
    address: 'Rozafa Hill, Shkodër', coords: [42.0465, 19.4937],
    image: u('1705405999485-188af37e0462'),
    hours: 'Mon–Sun 09:00–19:00',
    description: 'Legendary fortress above three rivers — 2,300 years of history and the best panorama in northern Albania.',
    tags: ['Fortress', 'Legend', 'Panorama'], featured: true, verified: false,
  },
  {
    id: 'r-tradita-shkoder', slug: 'tradita-geg-tosk-shkoder', name: 'Hotel Tradita Geg & Tosk', category: 'hotel', secondaryCategories: ['restaurant'],
    city: 'shkoder', country: 'albania', rating: 4.6, reviews: 1480, price: '$$', status: 'open',
    address: 'Rruga Edith Durham 4, Shkodër', coords: [42.0670, 19.5180],
    image: u('1582719508461-905c673771fd'),
    description: '400-year-old stone mansion turned ethnographic hotel — carved wood rooms and the best traditional table in Shkodër.',
    tags: ['Heritage', 'Traditional food', 'Ethnographic'], featured: true, verified: true,
  },
  {
    id: 'r-mrizizanave-shkoder', slug: 'mrizi-i-zanave', name: 'Mrizi i Zanave Agroturizëm', category: 'restaurant',
    city: 'shkoder', country: 'albania', rating: 4.9, reviews: 5840, price: '$$$', status: 'open',
    address: 'Fishtë, Lezhë (45 min from Shkodër)', coords: [41.8770, 19.7050],
    image: u('1555396273-367ea4eb4db5'),
    hours: 'Mon–Sun 12:00–22:00 (reserve ahead)',
    description: 'Albania\'s most celebrated farm-to-table restaurant — chef Altin Prenga\'s zero-km tasting menus in the hills of Fishtë.',
    tags: ['Farm-to-table', 'Slow food', 'Tasting menu', 'Iconic'], featured: true, verified: true,
  },

  // ================= BERAT =================
  {
    id: 'r-mangalemi-berat', slug: 'hotel-mangalemi-berat', name: 'Hotel Mangalemi', category: 'hotel',
    city: 'berat', country: 'albania', rating: 4.7, reviews: 1640, price: '$$', status: 'open',
    address: 'Mangalem Quarter, Berat', coords: [40.7077, 19.9450],
    image: u('1566073771259-6a8506099945'),
    description: 'Ottoman mansion in the UNESCO Mangalem quarter — terrace dining with castle views and famously warm hosts.',
    tags: ['UNESCO quarter', 'Ottoman house', 'Terrace'], featured: true, verified: true,
  },
  {
    id: 'r-lili-berat', slug: 'homemade-food-lili-berat', name: 'Homemade Food Lili', category: 'restaurant',
    city: 'berat', country: 'albania', rating: 4.9, reviews: 2860, price: '$$', status: 'open',
    address: 'Mangalem Quarter backstreets, Berat', coords: [40.7048, 19.9410],
    image: u('1555396273-367ea4eb4db5'),
    hours: 'Mon–Sun 12:00–22:00 (book ahead)',
    description: 'Tiny family courtyard restaurant — Lili cooks Berat\'s best home food. A handful of tables, book ahead.',
    tags: ['Home cooking', 'Family-run', 'Courtyard'], featured: true, verified: true,
  },
  {
    id: 'r-onufri-berat', slug: 'onufri-museum-berat', name: 'Onufri National Museum', category: 'museum',
    city: 'berat', country: 'albania', rating: 4.7, reviews: 1320, price: '$', status: 'open',
    address: 'Berat Castle, inside the Cathedral of St Mary', coords: [40.7107, 19.9396],
    image: u('1705405999485-188af37e0462'),
    hours: 'Tue–Sun 09:00–16:00',
    description: '16th-century iconography by master Onufri — luminous reds and golds inside the castle cathedral.',
    tags: ['Icons', 'Castle', 'UNESCO'], featured: false, verified: false,
  },
  {
    id: 'r-rafting-berat', slug: 'albania-rafting-osumi', name: 'Albania Rafting Group — Osumi Canyons', category: 'tour',
    city: 'berat', country: 'albania', rating: 4.8, reviews: 980, price: '$$$', status: 'open',
    address: 'Departures from Berat to Osumi Canyons', coords: [40.7040, 19.9530],
    image: u('1504280390367-361c6d9f38f4'),
    description: 'Raft through the spectacular Osumi Canyons (spring) or canyon-walk in summer — gear, guides and lunch included.',
    tags: ['Rafting', 'Canyons', 'Adventure', 'Guides'], featured: false, verified: true,
  },

  // ================= GJIROKASTRA =================
  {
    id: 'r-castle-gjirokastra', slug: 'gjirokastra-castle', name: 'Gjirokastra Castle', category: 'attraction',
    city: 'gjirokastra', country: 'albania', rating: 4.8, reviews: 4860, price: '$', status: 'open',
    address: 'Castle Hill, Gjirokastër', coords: [40.0726, 20.1411],
    image: px('33945650'),
    hours: 'Mon–Sun 09:00–19:00',
    description: 'One of the Balkans\' mightiest fortresses — arms museum, recovered US jet and views over the stone city.',
    tags: ['Fortress', 'UNESCO', 'Museum'], featured: true, verified: false,
  },
  {
    id: 'r-kuka-gjirokastra', slug: 'taverna-kuka-gjirokastra', name: 'Taverna Kuka', category: 'restaurant',
    city: 'gjirokastra', country: 'albania', rating: 4.6, reviews: 1980, price: '$$', status: 'open',
    address: 'Old Bazaar, Gjirokastër', coords: [40.0746, 20.1393],
    image: u('1517248135467-4c7edcad34c4'),
    hours: 'Mon–Sun 11:00–23:00',
    description: 'Stone-terrace taverna above the bazaar — qifqi rice balls, slow-cooked lamb and local Çelo Mezini wine.',
    tags: ['Qifqi', 'Terrace', 'Local wine'], featured: false, verified: true,
  },
  {
    id: 'r-argjiro-gjirokastra', slug: 'hotel-argjiro-gjirokastra', name: 'Hotel Argjiro', category: 'hotel',
    city: 'gjirokastra', country: 'albania', rating: 4.5, reviews: 880, price: '$$', status: 'open',
    address: 'Old Town entrance, Gjirokastër', coords: [40.0760, 20.1400],
    image: px('37569474'),
    description: 'Stone-built hotel at the old town gates — castle-view rooftop breakfast and easy parking.',
    tags: ['Stone house', 'Rooftop', 'Castle view'], featured: false, verified: true,
  },

  // ================= KORÇA =================
  {
    id: 'r-pazari-korca', slug: 'old-bazaar-korca', name: 'Pazari i Vjetër (Old Bazaar)', category: 'attraction',
    city: 'korca', country: 'albania', rating: 4.6, reviews: 2240, price: '$', status: 'open',
    address: 'Old Bazaar quarter, Korçë', coords: [40.6190, 20.7790],
    image: px('13288802'),
    description: 'Beautifully restored Ottoman bazaar — cobbled lanes of wine bars, serenata music and artisan shops.',
    tags: ['Ottoman', 'Wine bars', 'Serenata'], featured: true, verified: false,
  },
  {
    id: 'r-lifegallery-korca', slug: 'life-gallery-hotel-korca', name: 'Life Gallery Hotel', category: 'hotel',
    city: 'korca', country: 'albania', rating: 4.7, reviews: 760, price: '$$$', status: 'open',
    address: 'Bulevardi Shën Gjergji, Korçë', coords: [40.6160, 20.7770],
    image: u('1582719508461-905c673771fd'),
    description: 'Design hotel with art-filled interiors, spa and the city\'s most refined restaurant.',
    tags: ['Design', 'Spa', 'Art'], featured: false, verified: true,
  },
  {
    id: 'r-birraria-korca', slug: 'birraria-korca', name: 'Birraria Korça', category: 'bar',
    city: 'korca', country: 'albania', rating: 4.5, reviews: 1420, price: '$', status: 'open',
    address: 'Next to Birra Korça brewery, Korçë', coords: [40.6145, 20.7820],
    image: u('1514362545857-3bc16c4c7d1b'),
    hours: 'Mon–Sun 11:00–00:00',
    description: 'Beer garden of Albania\'s oldest brewery (1928) — unfiltered Korça pils straight from the tanks, grilled platters.',
    tags: ['Brewery', 'Beer garden', 'Since 1928'], featured: false, verified: true,
  },

  // ============ THETH / VALBONA / POGRADEC / KRUJA / DIVJAKË ============
  {
    id: 'r-blueeye-theth', slug: 'blue-eye-theth', name: 'Blue Eye of Theth (Kaprre)', category: 'attraction',
    city: 'theth', country: 'albania', rating: 4.8, reviews: 2120, price: '$', status: 'open',
    address: 'Kaprre, Theth National Park', coords: [42.3590, 19.7510],
    image: u('1693323243729-b1609557938f'),
    description: 'Impossibly turquoise alpine pool reached by a scenic 2-hour trail from Theth — icy, beautiful, unforgettable.',
    tags: ['Hike', 'Alpine pool', 'National park'], featured: true, verified: false,
  },
  {
    id: 'r-polia-theth', slug: 'bujtina-polia-theth', name: 'Bujtina Polia', category: 'villa', secondaryCategories: ['hotel'],
    city: 'theth', country: 'albania', rating: 4.8, reviews: 640, price: '$$', status: 'open',
    address: 'Theth village center', coords: [42.3950, 19.7710],
    image: u('1564013799919-ab600027ffc6'),
    description: 'Classic stone guesthouse under the Accursed Mountains — home-cooked dinners and trailheads at the door.',
    tags: ['Guesthouse', 'Home cooking', 'Trailhead'], featured: false, verified: true,
  },
  {
    id: 'r-rilindja-valbona', slug: 'hotel-rilindja-valbona', name: 'Hotel Rilindja', category: 'hotel',
    city: 'valbona', country: 'albania', rating: 4.7, reviews: 720, price: '$$', status: 'open',
    address: 'Valbona Valley National Park', coords: [42.4450, 19.8580],
    image: u('1566073771259-6a8506099945'),
    description: 'The original Valbona lodge — pine-forest cabins, hearty alpine food and the Valbona–Theth trail at your door.',
    tags: ['Alpine lodge', 'Valbona pass', 'Cabins'], featured: false, verified: true,
  },
  {
    id: 'r-drilon-pogradec', slug: 'drilon-springs-pogradec', name: 'Drilon Springs Park', category: 'park',
    city: 'pogradec', country: 'albania', rating: 4.6, reviews: 1840, price: '$', status: 'open',
    address: 'Drilon, 5 km east of Pogradec', coords: [40.9180, 20.6800],
    image: u('1559827260-dc66d52bef19'),
    description: 'Crystal springs feeding Lake Ohrid — swan-filled canals, willow shade and waterside restaurants.',
    tags: ['Springs', 'Swans', 'Picnic'], featured: false, verified: false,
  },
  {
    id: 'r-enkelana-pogradec', slug: 'hotel-enkelana-pogradec', name: 'Hotel Enkelana', category: 'hotel',
    city: 'pogradec', country: 'albania', rating: 4.4, reviews: 560, price: '$$', status: 'open',
    address: 'Lakefront boulevard, Pogradec', coords: [40.9035, 20.6540],
    image: px('37569474'),
    description: 'Lakefront hotel with Ohrid-view balconies — koran trout dinners and sunrise swims off the pier.',
    tags: ['Lakefront', 'Koran trout', 'Balconies'], featured: false, verified: true,
  },
  {
    id: 'r-bazaar-kruja', slug: 'kruja-old-bazaar', name: 'Kruja Old Bazaar', category: 'shopping', secondaryCategories: ['attraction'],
    city: 'kruja', country: 'albania', rating: 4.7, reviews: 2680, price: '$$', status: 'open',
    address: 'Below Kruja Castle, Krujë', coords: [41.5078, 19.7935],
    image: u('1441986300917-64674bd600d8'),
    hours: 'Mon–Sun 09:00–19:00',
    description: '500-year-old wooden bazaar — antique filigree, qeleshe felt hats, kilims and Albania\'s best souvenirs.',
    tags: ['Antiques', 'Kilims', 'Souvenirs', 'Ottoman'], featured: true, verified: false,
  },
  {
    id: 'r-karavasta-divjake', slug: 'divjake-karavasta-park', name: 'Divjakë–Karavasta National Park', category: 'park',
    city: 'divjake', country: 'albania', rating: 4.6, reviews: 1380, price: '$', status: 'open',
    address: 'Karavasta Lagoon, Divjakë', coords: [40.9300, 19.4870],
    image: px('18428657'),
    description: 'The largest lagoon in Albania — curly pelicans, flamingos, pine forest trails and wild Adriatic beach.',
    tags: ['Pelicans', 'Flamingos', 'Lagoon', 'Birdwatching'], featured: false, verified: false,
  },

  // ================= PRISTINA (KOSOVO) =================
  {
    id: 'r-swissdiamond-pristina', slug: 'swiss-diamond-hotel-pristina', name: 'Swiss Diamond Hotel', category: 'hotel',
    city: 'pristina', country: 'kosovo', rating: 4.7, reviews: 1860, price: '$$$$', status: 'open',
    address: 'Sheshi Nëna Terezë, Pristina', coords: [42.6594, 21.1577],
    image: u('1566073771259-6a8506099945'),
    description: 'Kosovo\'s flagship 5-star on Mother Teresa Square — marble lobby, spa and diplomatic-grade service.',
    tags: ['5-star', 'Spa', 'Square view'], featured: true, verified: true,
  },
  {
    id: 'r-renaissance-pristina', slug: 'renaissance-restaurant-pristina', name: 'Renaissance Restaurant', category: 'restaurant',
    city: 'pristina', country: 'kosovo', rating: 4.8, reviews: 1240, price: '$$$', status: 'open',
    address: 'Rruga Xhemajl Mustafa, Pristina', coords: [42.6655, 21.1620],
    image: u('1517248135467-4c7edcad34c4'),
    hours: 'Mon–Sat 18:00–23:00',
    description: 'No menu, no rush — a legendary family table where mezes keep arriving with house wine and stories.',
    tags: ['No menu', 'Mezes', 'House wine', 'Legendary'], featured: true, verified: true,
  },
  {
    id: 'r-tiffany-pristina', slug: 'tiffany-restaurant-pristina', name: 'Tiffany', category: 'restaurant',
    city: 'pristina', country: 'kosovo', rating: 4.6, reviews: 1480, price: '$$$', status: 'open',
    address: 'Rruga Fehmi Agani, Pristina', coords: [42.6603, 21.1556],
    image: u('1514933651103-005eec06c04b'),
    hours: 'Mon–Sun 11:00–23:00',
    description: 'Garden-courtyard classic serving slow-baked lamb, sarma and seasonal Kosovar dishes to Pristina\'s who\'s-who.',
    tags: ['Garden', 'Slow-baked lamb', 'Classic'], featured: false, verified: true,
  },
  {
    id: 'r-ditenat-pristina', slug: 'dit-e-nat-pristina', name: "Dit' e Nat'", category: 'cafe',
    city: 'pristina', country: 'kosovo', rating: 4.7, reviews: 1620, price: '$', status: 'open',
    address: 'Rruga Fazli Grajqevci 5, Pristina', coords: [42.6597, 21.1645],
    image: u('1501339847302-ac426a4a7cbb'),
    hours: 'Mon–Sun 08:00–23:00',
    description: 'Bookshop-café-bar hybrid — specialty coffee by day, acoustic sets and natural wine by night.',
    tags: ['Bookshop', 'Specialty coffee', 'Live music'], featured: true, verified: true,
  },
  {
    id: 'r-newborn-pristina', slug: 'newborn-monument-pristina', name: 'NEWBORN Monument', category: 'attraction',
    city: 'pristina', country: 'kosovo', rating: 4.5, reviews: 5240, price: '$', status: 'open',
    address: 'Sheshi Nëna Terezë, Pristina', coords: [42.6598, 21.1577],
    image: px('34061704'),
    description: 'The typographic symbol of Kosovo\'s 2008 independence — repainted every year with a new theme.',
    tags: ['Independence', 'Photo spot', 'Iconic'], featured: true, verified: false,
  },
  {
    id: 'r-germia-pristina', slug: 'germia-park-pristina', name: 'Gërmia Park', category: 'park',
    city: 'pristina', country: 'kosovo', rating: 4.6, reviews: 2880, price: '$', status: 'open',
    address: 'Gërmia, 4 km east of Pristina center', coords: [42.6730, 21.1990],
    image: u('1441974231531-c6227db76b6e'),
    description: 'Pristina\'s green lung — oak forest trails, a giant open-air pool and weekend qebapa barbecues.',
    tags: ['Forest', 'Open-air pool', 'Trails'], featured: false, verified: false,
  },
  {
    id: 'r-zone-pristina', slug: 'zone-club-pristina', name: 'Zone Club', category: 'nightclub',
    city: 'pristina', country: 'kosovo', rating: 4.4, reviews: 1180, price: '$$$', status: 'open',
    address: 'Industrial zone, Pristina', coords: [42.6543, 21.1492],
    image: u('1566737236500-c8ac43014a67'),
    hours: 'Fri–Sat 23:00–06:00',
    description: 'Kosovo\'s techno temple — warehouse energy, international bookings and sunrise finishes.',
    tags: ['Techno', 'Warehouse', 'International DJs'], featured: false, verified: true,
  },
  {
    id: 'r-prishtinamall-pristina', slug: 'prishtina-mall', name: 'Prishtina Mall', category: 'shopping',
    city: 'pristina', country: 'kosovo', rating: 4.6, reviews: 6420, price: '$$', status: 'open',
    address: 'Magjistralja Prishtinë–Ferizaj, Pristina', coords: [42.5980, 21.0890],
    image: u('1441986300917-64674bd600d8'),
    hours: 'Mon–Sun 10:00–22:00',
    description: 'The biggest mall in the region — 300+ stores, IMAX cinema, ice rink and a full food boulevard.',
    tags: ['300+ stores', 'IMAX', 'Ice rink'], featured: false, verified: true,
  },

  // ================= PRIZREN (KOSOVO) =================
  {
    id: 'r-tesyla-prizren', slug: 'te-syla-prizren', name: "Te Syla 'Al Hambra'", category: 'restaurant',
    city: 'prizren', country: 'kosovo', rating: 4.7, reviews: 3240, price: '$', status: 'open',
    address: 'Near Shadërvan Square, Prizren', coords: [42.2133, 20.7420],
    image: px('13288802'),
    hours: 'Mon–Sun 08:00–23:00',
    description: 'The most famous qebaptore in Kosovo — riverside terrace, charcoal qebapa and pite since 1966.',
    tags: ['Qebapa', 'Since 1966', 'Riverside'], featured: true, verified: true,
  },
  {
    id: 'r-fortress-prizren', slug: 'prizren-fortress', name: 'Prizren Fortress (Kalaja)', category: 'attraction',
    city: 'prizren', country: 'kosovo', rating: 4.8, reviews: 5680, price: '$', status: 'open',
    address: 'Kalaja Hill, Prizren', coords: [42.2087, 20.7456],
    image: px('33092891'),
    hours: 'Open 24/7',
    description: 'Byzantine-Ottoman fortress above the old town — climb at golden hour for Prizren\'s postcard panorama.',
    tags: ['Fortress', 'Sunset', 'Panorama'], featured: true, verified: false,
  },
  {
    id: 'r-centrum-prizren', slug: 'hotel-centrum-prizren', name: 'Hotel Centrum Prizren', category: 'hotel',
    city: 'prizren', country: 'kosovo', rating: 4.6, reviews: 940, price: '$$', status: 'open',
    address: 'Old Town, Prizren', coords: [42.2150, 20.7430],
    image: u('1582719508461-905c673771fd'),
    description: 'Boutique stay steps from Shadërvan — stone walls, river views and generous Kosovar breakfasts.',
    tags: ['Old town', 'River view', 'Boutique'], featured: false, verified: true,
  },

  // ================= PEJA / GJAKOVA / BREZOVICA / MITROVICA =================
  {
    id: 'r-patriarchate-peja', slug: 'patriarchate-of-pec', name: 'Patriarchate of Peć Monastery', category: 'attraction',
    city: 'peja', country: 'kosovo', rating: 4.7, reviews: 1860, price: '$', status: 'open',
    address: 'Rugova Gorge entrance, Peja', coords: [42.6610, 20.2680],
    image: u('1705405999485-188af37e0462'),
    hours: 'Mon–Sun 09:00–17:00',
    description: 'UNESCO-listed medieval monastery at the mouth of Rugova Canyon — frescoed churches in serene gardens.',
    tags: ['UNESCO', 'Frescoes', 'Monastery'], featured: true, verified: false,
  },
  {
    id: 'r-dukagjini-peja', slug: 'hotel-dukagjini-peja', name: 'Hotel Dukagjini', category: 'hotel',
    city: 'peja', country: 'kosovo', rating: 4.5, reviews: 1080, price: '$$$', status: 'open',
    address: 'Sheshi Haxhi Zeka, Peja', coords: [42.6598, 20.2890],
    image: px('37569474'),
    description: 'Historic grand hotel on Peja\'s main square — riverside terrace facing the Accursed Mountains.',
    tags: ['Historic', 'River terrace', 'Mountain view'], featured: false, verified: true,
  },
  {
    id: 'r-bna-peja', slug: 'balkan-natural-adventure-peja', name: 'Balkan Natural Adventure', category: 'tour',
    city: 'peja', country: 'kosovo', rating: 4.9, reviews: 520, price: '$$$', status: 'open',
    address: 'Rruga Mbretëresha Teutë, Peja', coords: [42.6585, 20.2900],
    image: u('1551632811-561732d1e306'), website: 'https://bnadventure.com',
    description: 'Peaks of the Balkans specialists — via ferrata, ziplines, snowshoeing and the famous 192km cross-border trek.',
    tags: ['Peaks of the Balkans', 'Via ferrata', 'Zipline'], featured: true, verified: true,
  },
  {
    id: 'r-carshia-gjakova', slug: 'carshia-e-jupave-gjakova', name: 'Hotel Çarshia e Jupave', category: 'hotel', secondaryCategories: ['restaurant'],
    city: 'gjakova', country: 'kosovo', rating: 4.6, reviews: 780, price: '$$', status: 'open',
    address: 'Çarshia e Madhe (Grand Bazaar), Gjakova', coords: [42.3830, 20.4300],
    image: u('1566073771259-6a8506099945'),
    description: 'Ottoman-style hotel inside the longest bazaar in the Balkans — wood-carved rooms and a famed grill house.',
    tags: ['Grand Bazaar', 'Ottoman', 'Grill'], featured: false, verified: true,
  },
  {
    id: 'r-skiresort-brezovica', slug: 'brezovica-ski-resort', name: 'Brezovica Ski Resort', category: 'attraction',
    city: 'brezovica', country: 'kosovo', rating: 4.4, reviews: 1640, price: '$$', status: 'open',
    address: 'Sharr Mountains, Brezovica', coords: [42.1580, 21.0560],
    image: u('1693323243729-b1609557938f'),
    hours: 'Dec–Apr 09:00–16:00 (summer hiking year-round)',
    description: 'Kosovo\'s legendary ski mountain — 2,500m slopes, powder bowls in winter and Sharr hiking in summer.',
    tags: ['Skiing', 'Sharr Mountains', 'Powder'], featured: true, verified: false,
  },
  {
    id: 'r-miners-mitrovica', slug: 'miners-monument-mitrovica', name: "Miners' Monument (Shrine of the Revolution)", category: 'attraction',
    city: 'mitrovica', country: 'kosovo', rating: 4.3, reviews: 680, price: '$', status: 'open',
    address: 'Miners\' Hill, Mitrovica', coords: [42.8950, 20.8700],
    image: px('34061704'),
    description: 'Bogdanović\'s monumental concrete ode to Trepča miners — brutalist icon with sweeping city views.',
    tags: ['Brutalist', 'Monument', 'Viewpoint'], featured: false, verified: false,
  },

  // ================= SKOPJE (NORTH MACEDONIA) =================
  {
    id: 'r-marriott-skopje', slug: 'marriott-skopje', name: 'Skopje Marriott Hotel', category: 'hotel',
    city: 'skopje', country: 'north-macedonia', rating: 4.7, reviews: 2140, price: '$$$$', status: 'open',
    address: 'Plostad Makedonija 7, Skopje', coords: [41.9956, 21.4305],
    image: u('1566073771259-6a8506099945'),
    description: '5-star landmark directly on Macedonia Square — executive lounge, spa and bridge-view suites.',
    tags: ['5-star', 'Macedonia Square', 'Spa'], featured: true, verified: true,
  },
  {
    id: 'r-stonebridge-skopje', slug: 'stone-bridge-skopje', name: 'Stone Bridge', category: 'attraction',
    city: 'skopje', country: 'north-macedonia', rating: 4.6, reviews: 7240, price: '$', status: 'open',
    address: 'Vardar River, between Macedonia Sq & Old Bazaar', coords: [41.9971, 21.4337],
    image: u('1684846836837-a56157f8e461'),
    description: '15th-century Ottoman bridge over the Vardar — the symbol of Skopje linking new town and Old Bazaar.',
    tags: ['Ottoman', 'Vardar', 'Iconic'], featured: true, verified: false,
  },
  {
    id: 'r-kale-skopje', slug: 'kale-fortress-skopje', name: 'Skopje Fortress (Kale)', category: 'attraction',
    city: 'skopje', country: 'north-macedonia', rating: 4.5, reviews: 4180, price: '$', status: 'open',
    address: 'Samoilova, above the Old Bazaar, Skopje', coords: [42.0008, 21.4330],
    image: u('1705405999485-188af37e0462'),
    hours: 'Open 24/7',
    description: '6th-century ramparts above the city — free entry, sunset walls and views across the Vardar valley.',
    tags: ['Fortress', 'Free entry', 'Sunset'], featured: false, verified: false,
  },
  {
    id: 'r-pelister-skopje', slug: 'restaurant-pelister-skopje', name: 'Restaurant Pelister', category: 'restaurant', secondaryCategories: ['cafe'],
    city: 'skopje', country: 'north-macedonia', rating: 4.4, reviews: 2680, price: '$$', status: 'open',
    address: 'Plostad Makedonija, Skopje', coords: [41.9947, 21.4300],
    image: u('1738247122284-46d2b810174f'),
    hours: 'Mon–Sun 08:00–00:00',
    description: 'Square-side classic since the 1920s — Macedonian grills, tavče gravče and people-watching terrace.',
    tags: ['Tavče gravče', 'Terrace', 'Classic'], featured: false, verified: true,
  },
  {
    id: 'r-oldtownbrewery-skopje', slug: 'old-town-brewery-skopje', name: 'Old Town Brewery', category: 'bar',
    city: 'skopje', country: 'north-macedonia', rating: 4.6, reviews: 1840, price: '$$', status: 'open',
    address: 'Gradište 1, Old Bazaar, Skopje', coords: [41.9990, 21.4365],
    image: u('1514362545857-3bc16c4c7d1b'),
    hours: 'Mon–Sun 12:00–01:00',
    description: 'Craft brewery in the heart of the Old Bazaar — unfiltered house ales under centuries-old plane trees.',
    tags: ['Craft beer', 'Old Bazaar', 'Garden'], featured: true, verified: true,
  },
  {
    id: 'r-motherteresa-skopje', slug: 'mother-teresa-memorial-skopje', name: 'Memorial House of Mother Teresa', category: 'museum',
    city: 'skopje', country: 'north-macedonia', rating: 4.4, reviews: 3420, price: '$', status: 'open',
    address: 'Makedonija 9, Skopje', coords: [41.9933, 21.4313],
    hours: 'Mon–Fri 09:00–20:00 · Sat–Sun 09:00–14:00',
    image: u('1684846836837-a56157f8e461'),
    description: 'Free museum on the site where Mother Teresa was baptised in 1910 — relics, letters and a glass chapel.',
    tags: ['Free entry', 'Mother Teresa', 'Chapel'], featured: false, verified: false,
  },
  {
    id: 'r-citypark-skopje', slug: 'city-park-skopje', name: 'Skopje City Park', category: 'park',
    city: 'skopje', country: 'north-macedonia', rating: 4.6, reviews: 3860, price: '$', status: 'open',
    address: 'Boulevard Ilinden, Skopje', coords: [42.0070, 21.4180],
    image: u('1441974231531-c6227db76b6e'),
    description: 'The city\'s favorite green escape — lakes, rose gardens, bike lanes and summer open-air bars.',
    tags: ['Lakes', 'Cycling', 'Open-air bars'], featured: false, verified: false,
  },
  {
    id: 'r-citymall-skopje', slug: 'skopje-city-mall', name: 'Skopje City Mall', category: 'shopping',
    city: 'skopje', country: 'north-macedonia', rating: 4.5, reviews: 5240, price: '$$', status: 'open',
    address: 'Ljubljanska 4, Karpoš, Skopje', coords: [42.0046, 21.3920],
    image: u('1441986300917-64674bd600d8'),
    hours: 'Mon–Sun 10:00–22:00',
    description: 'North Macedonia\'s premier mall — 130+ brands, cinema multiplex and the city\'s best food court.',
    tags: ['Brands', 'Cinema', 'Food court'], featured: false, verified: true,
  },

  // ================= OHRID (NORTH MACEDONIA) =================
  {
    id: 'r-kaneo-church-ohrid', slug: 'st-john-kaneo-ohrid', name: 'Church of St. John at Kaneo', category: 'attraction',
    city: 'ohrid', country: 'north-macedonia', rating: 4.9, reviews: 8640, price: '$', status: 'open',
    address: 'Kaneo cliff, Ohrid', coords: [41.1106, 20.7889],
    image: u('1537113799915-0a24165b3f72'),
    description: 'The most photographed church in the Balkans — a 13th-century jewel on a cliff above impossibly blue water.',
    tags: ['Iconic', 'Cliff', 'UNESCO', 'Photo spot'], featured: true, verified: false,
  },
  {
    id: 'r-samuelfortress-ohrid', slug: 'samuels-fortress-ohrid', name: "Samuel's Fortress", category: 'attraction',
    city: 'ohrid', country: 'north-macedonia', rating: 4.6, reviews: 4280, price: '$', status: 'open',
    address: 'Upper Old Town, Ohrid', coords: [41.1133, 20.7937],
    image: u('1705405999485-188af37e0462'),
    hours: 'Mon–Sun 09:00–19:00',
    description: 'Tsar Samuel\'s 10th-century walls crown the old town — walk the ramparts for lake-to-mountain panoramas.',
    tags: ['Fortress', 'Ramparts', 'Panorama'], featured: false, verified: false,
  },
  {
    id: 'r-cubalibre-ohrid', slug: 'cuba-libre-ohrid', name: 'Cuba Libre', category: 'bar', secondaryCategories: ['nightclub'],
    city: 'ohrid', country: 'north-macedonia', rating: 4.4, reviews: 2240, price: '$$', status: 'open',
    address: 'Kosta Abrash, Old Town waterfront, Ohrid', coords: [41.1119, 20.7997],
    image: u('1551024709-8f23befc6f87'),
    hours: 'Mon–Sun 18:00–03:00',
    description: 'Ohrid\'s legendary lakeside party bar — mojitos on the boardwalk and dancing till late every summer night.',
    tags: ['Lakeside', 'Mojitos', 'Dancing'], featured: true, verified: true,
  },
  {
    id: 'r-stsofija-ohrid', slug: 'villa-st-sofija-ohrid', name: 'Villa St. Sofija', category: 'villa', secondaryCategories: ['hotel'],
    city: 'ohrid', country: 'north-macedonia', rating: 4.7, reviews: 680, price: '$$$', status: 'open',
    address: 'Kosta Abrash 64, Old Town, Ohrid', coords: [41.1124, 20.7949],
    image: u('1600596542815-ffad4c1539a9'),
    description: 'Restored Ottoman villa beside St. Sophia cathedral — antique interiors and a vine-shaded breakfast terrace.',
    tags: ['Ottoman villa', 'Old town', 'Antiques'], featured: false, verified: true,
  },
  {
    id: 'r-gradiste-ohrid', slug: 'gradiste-beach-ohrid', name: 'Gradište Beach', category: 'beach',
    city: 'ohrid', country: 'north-macedonia', rating: 4.5, reviews: 1620, price: '$', status: 'open',
    address: 'Ohrid–St. Naum road, 18 km from Ohrid', coords: [41.0410, 20.7860],
    image: u('1519046904884-53103b34b206'),
    description: 'Ohrid\'s clearest swimming spot — pebble coves, beach bars and ancient ruins on the headland above.',
    tags: ['Clear water', 'Coves', 'Beach bars'], featured: false, verified: false,
  },

  // ============ BITOLA / STRUGA / TETOVO / KRUSHEVO / MAVROVO ============
  {
    id: 'r-shiroksokak-bitola', slug: 'shirok-sokak-bitola', name: 'Širok Sokak', category: 'attraction',
    city: 'bitola', country: 'north-macedonia', rating: 4.6, reviews: 3840, price: '$', status: 'open',
    address: 'Marshal Tito Street, Bitola', coords: [41.0322, 21.3343],
    image: px('13288802'),
    description: 'Bitola\'s elegant café promenade — neoclassical consulates, street musicians and the Balkans\' best corzo.',
    tags: ['Promenade', 'Cafés', 'Neoclassical'], featured: true, verified: false,
  },
  {
    id: 'r-heraclea-bitola', slug: 'heraclea-lyncestis-bitola', name: 'Heraclea Lyncestis', category: 'attraction',
    city: 'bitola', country: 'north-macedonia', rating: 4.6, reviews: 2120, price: '$', status: 'open',
    address: '2 km south of Bitola center', coords: [41.0114, 21.3415],
    image: px('33945650'),
    hours: 'Mon–Sun 09:00–18:00',
    description: 'Ancient city founded by Philip II of Macedon — Roman theatre and some of the finest mosaics in the Balkans.',
    tags: ['Ancient', 'Mosaics', 'Roman theatre'], featured: false, verified: false,
  },
  {
    id: 'r-epinal-bitola', slug: 'hotel-epinal-bitola', name: 'Hotel Epinal', category: 'hotel',
    city: 'bitola', country: 'north-macedonia', rating: 4.3, reviews: 980, price: '$$', status: 'open',
    address: 'Širok Sokak, Bitola', coords: [41.0334, 21.3320],
    image: px('37569474'),
    description: 'Bitola\'s central hotel right on Širok Sokak — casino, spa and Pelister mountain views.',
    tags: ['Central', 'Spa', 'Casino'], featured: false, verified: true,
  },
  {
    id: 'r-drim-struga', slug: 'hotel-drim-struga', name: 'Hotel Drim', category: 'hotel',
    city: 'struga', country: 'north-macedonia', rating: 4.4, reviews: 1240, price: '$$', status: 'open',
    address: 'Kej Boris Kidrič, Struga lakefront', coords: [41.1768, 20.6772],
    image: u('1571896349842-33c89424de2d'),
    description: 'Struga\'s lakefront classic — private beach, pools and sunset views where the Drin leaves Lake Ohrid.',
    tags: ['Lakefront', 'Private beach', 'Pools'], featured: false, verified: true,
  },
  {
    id: 'r-poetrybridge-struga', slug: 'bridge-of-poetry-struga', name: 'Bridge of Poetry', category: 'attraction',
    city: 'struga', country: 'north-macedonia', rating: 4.4, reviews: 1480, price: '$', status: 'open',
    address: 'River Drin, Struga center', coords: [41.1775, 20.6790],
    image: u('1537113799915-0a24165b3f72'),
    description: 'Where world poets read over the Drin each August — Struga\'s romantic heart since 1962.',
    tags: ['Poetry festival', 'River Drin', 'Romantic'], featured: false, verified: false,
  },
  {
    id: 'r-paintedmosque-tetovo', slug: 'painted-mosque-tetovo', name: 'Šarena Džamija (Painted Mosque)', category: 'attraction',
    city: 'tetovo', country: 'north-macedonia', rating: 4.7, reviews: 2860, price: '$', status: 'open',
    address: 'River Pena, Tetovo', coords: [42.0097, 20.9663],
    image: px('33092891'),
    description: '1438 mosque painted like a jewel box — 30,000 eggs went into its dazzling floral facades.',
    tags: ['Ottoman', 'Painted facades', 'Unique'], featured: true, verified: false,
  },
  {
    id: 'r-makedonium-krusevo', slug: 'makedonium-krusevo', name: 'Makedonium (Ilinden Monument)', category: 'attraction',
    city: 'krusevo', country: 'north-macedonia', rating: 4.6, reviews: 1320, price: '$', status: 'open',
    address: 'Gumenje hill, Krushevo', coords: [41.3777, 21.2495],
    image: u('1684846836837-a56157f8e461'),
    hours: 'Tue–Sun 09:00–17:00',
    description: 'The space-age 1974 monument to the Ilinden Uprising — stained glass and sculpture inside a concrete star.',
    tags: ['Brutalist', 'Ilinden', 'Stained glass'], featured: false, verified: false,
  },
  {
    id: 'r-submergedchurch-mavrovo', slug: 'submerged-church-mavrovo', name: 'St. Nicholas Submerged Church', category: 'attraction',
    city: 'mavrovo', country: 'north-macedonia', rating: 4.5, reviews: 1180, price: '$', status: 'open',
    address: 'Mavrovo Lake', coords: [41.6560, 20.7510],
    image: u('1537113799915-0a24165b3f72'),
    description: 'A 19th-century church rising half-drowned from Mavrovo Lake — hauntingly beautiful in every season.',
    tags: ['Submerged', 'Lake', 'Photo spot'], featured: true, verified: false,
  },
];
